import { combineReducers } from 'redux';

import consultar from './consultar/reducer';
import onboarding from './onboarding/reducer';
import contato from './dadosRequerente/reducer';
import dadosPedido from './dadosPedido/reducer';
import anexos from './anexos/reducer';
import vinculos from './vinculos/reducer';
import disponibilidade from './disponibilidade/reducer';
import orgaoPagador from './orgaoPagador/reducer';
import concluir from './concluir/reducer';
import detalhar from './detalhar/reducer';
import cancelar from './cancelar/reducer';
import pericia from './pericia/reducer';
import iniciar from './iniciar/reducer';
import prorrogar from './prorrogar/reducer';
import disponibilidadePericia from './disponibilidadePericia/reducer';
import parametros from './parametros/reducer';
import atestadoEletronico from './atestadoEletronico/reducer';
import converter from './converter/reducer';

const appReducer = combineReducers({
  detalhar,
  consultar,
  onboarding,
  contato,
  dadosPedido,
  anexos,
  vinculos,
  disponibilidade,
  disponibilidadePericia,
  orgaoPagador,
  concluir,
  cancelar,
  pericia,
  iniciar,
  prorrogar,
  parametros,
  atestadoEletronico,
  converter
});

const sagReducer = (state, action) => {
  return appReducer(state, action);
};


export default sagReducer;
